
export default {
  emits: ['update'],
  data () {
    return {
      user: {},
      limit: 0
    }
  },
  methods: {
    open(user) {
      this.user = user
      this.limit = String(user.storage_limit)
      this.$refs.modal.open()
    },
    close () {
      this.$refs.modal.close()
    },
    async submit() {
      const data = {storage_limit: +this.limit}
      this.$emit('update', this.user.id, data)
      this.close()
    }
  }
}
